<p-button
    class="btn-primary"
    (onClick)="onClick()"
    [pTooltip]="tooltip"
    icon="fas fa-plus"
    [label]="label"
    tooltipPosition="left">
</p-button>